import React from 'react';
import { Link } from 'react-router';

import { cn } from '~/utils/cn';

function Logo({
  className,
  centered,
  onClick
}: {
  className?: string;
  centered?: boolean;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}) {
  return (
    <Link
      to="/"
      data-cy="logo"
      className={cn(
        'absolute size-fit z-30 transition-all left-3 top-safe-offset-3 md:left-6 md:top-safe-offset-6 cursor-pointer',
        centered && 'max-md:left-1/2 max-md:-translate-x-1/2',
        className
      )}
      {...(onClick && {
        onClick: e => {
          e.preventDefault();
          onClick(e);
        }
      })}
    >
      <img
        src="/logo-beta.svg"
        alt="Go to the Respawwwn.com homepage"
        className="block w-32 max-w-[unset]"
        translate="no"
        fetchPriority="high"
      />
    </Link>
  );
}

export default Logo;
